


































































































import LoadingOverlay from "@/components/shared/LoadingOverlay.vue";
import { Component, Vue } from "vue-property-decorator";
import Menu from "../../components/admin/Menu.vue";

import ConferenceForm from "@/components/admin/conference/ConferenceForm.vue";
import {
  allConferences,
  deleteConference,
  editConference,
  insertConference,
} from "@/graphql/conference";
import { allContent } from "@/graphql/content";
import {
  addMember,
  allCommitteeMembers,
  deleteMember,
  updateChairman,
  updateCoChairman,
  updateHonoraryChairman,
  updateMainOrganizer,
  updateScientificCommitteeChairman,
} from "@/graphql/members";
import { allTopics } from "@/graphql/topics";
import { IConference } from "@/models/Conference.model";

import AboutForm from "@/components/admin/content/AboutForm.vue";
import CarouselForm from "@/components/admin/content/CarouselForm.vue";
import DatesForm from "@/components/admin/content/ImportantDatesForm.vue";
import InfoForm from "@/components/admin/content/InfoForm.vue";
import ProgrammeForm from "@/components/admin/content/ProgrammeForm.vue";
import PublicationForm from "@/components/admin/content/PublicationForm.vue";
import RegistrationForm from "@/components/admin/content/RegistrationForm.vue";
import SponsorsForm from "@/components/admin/content/SponsorsForm.vue";
import TopicsForm from "@/components/admin/content/TopicsForm.vue";
import VenueForm from "@/components/admin/content/VenueForm.vue";
import { updateContent } from "@/graphql/content";
import { deleteTopic, insertTopic } from "@/graphql/topics";
import { IContent } from "@/models/Content.model";
import { ITopic } from "../../models/Topic.model";

import AddMembers from "@/components/admin/members/AddMembers.vue";
import MemberForm from "@/components/admin/members/MemberForm.vue";
import ChairmenTable from "../../components/admin/members/ChairmenTable.vue";
import CustomTable from "../../components/admin/members/CustomTable.vue";
import MemberTable from "../../components/admin/members/MemberTable.vue";
import { allMembers, updateAdmin, updateMember } from "../../graphql/members";
import { IMember } from "../../models/Member.model";

import ArticleTable from "@/components/admin/articles/ArticleTable.vue";
import {
  allArticles,
  reviewArticle,
  sendAcceptanceLetter,
  updateArticle,
  updateRole,
} from "../../graphql/article";
import { IArticle } from "../../models/Article.model";

import AdminTable from "@/components/admin/members/AdminTable.vue";

@Component({
  components: {
    LoadingOverlay,
    Menu,
    ConferenceForm,
    CarouselForm,
    AboutForm,
    DatesForm,
    InfoForm,
    PublicationForm,
    ProgrammeForm,
    VenueForm,
    RegistrationForm,
    SponsorsForm,
    TopicsForm,
    CustomTable,
    AddMembers,
    MemberTable,
    ChairmenTable,
    MemberForm,
    ArticleTable,
    AdminTable,
  },
  apollo: {
    allMembers() {
      return { query: allMembers, skip: true, variables: { conference: "" } };
    },
    allArticles() {
      return { query: allArticles, skip: true, variables: { conference: "" } };
    },
    allConferences() {
      return { query: allConferences, skip: true };
    },

    allTopics() {
      return { query: allTopics, skip: true, variables: { conference: "" } };
    },
    allCommitteeMembers() {
      return {
        query: allCommitteeMembers,
        skip: true,
        variables: { conference: "" },
      };
    },
    allContent() {
      return { query: allContent, skip: true, variables: { conference: "" } };
    },
  },
})
export default class AdminView extends Vue {
  get conference() {
    return this.$store.getters.getConferenceId;
  }

  get conferenceTitle() {
    return this.$store.getters.getConferenceTitle;
  }

  get allConferences() {
    return this.$store.getters.getAllConferences;
  }

  get isAdmin() {
    return this.$store.getters.isAdmin;
  }

  get isSuperAdmin() {
    return this.$store.getters.isSuperAdmin;
  }

  get hasEditConferences() {
    return this.$store.getters.hasEditConferences;
  }

  get hasEditContent() {
    return this.$store.getters.hasEditContent;
  }

  get hasEditMembers() {
    return this.$store.getters.hasEditMembers;
  }

  get hasEditArticles() {
    return this.$store.getters.hasEditArticles;
  }
  get hasEditAdmins() {
    return this.$store.getters.hasEditAdmins;
  }

  reviewers: IMember[] = [];
  isLoading = false;

  async getTopics(conf: string) {
    this.$apollo.queries.allTopics.setVariables({
      conference: conf,
    });
    this.$apollo.queries.allTopics.skip = false;
    await this.$apollo.queries.allTopics.refetch();
  }

  async getContent(conf: string) {
    this.$apollo.queries.allContent.setVariables({
      conference: conf,
    });
    this.$apollo.queries.allContent.skip = false;
    await this.$apollo.queries.allContent.refetch();
  }

  async getAllCommittees(conf: string) {
    this.$apollo.queries.allCommitteeMembers.setVariables({
      conference: conf,
    });
    this.$apollo.queries.allCommitteeMembers.skip = false;
    await this.$apollo.queries.allCommitteeMembers.refetch();
  }

  async pickConference(id: string) {
    //@ts-ignore
    const pickedConference = this.allConferences.find(
      (conference: any) => conference._id == id
    );
    localStorage.setItem("conference", JSON.stringify(pickedConference));
    window.location.reload();
    this.$store.commit("setConference", pickedConference);

    await this.getTopics(pickedConference._id);
    await this.getContent(pickedConference._id);
    await this.getAllCommittees(pickedConference._id);
    // @ts-ignore
    this.$store.commit("setTopics", this.allTopics);
    // @ts-ignore
    this.$store.commit("setContent", this.allContent);
    // @ts-ignore
    this.$store.commit("setCommittee", this.allCommitteeMembers);
    this.$store.commit("setShowNav", true);
    this.reloadSuperAdmin(pickedConference._id);
  }

  async reloadSuperAdmin(conf: string) {
    this.$apollo.queries.allMembers.setVariables({
      conference: conf,
    });
    this.$apollo.queries.allMembers.skip = false;
    const res = await this.$apollo.queries.allMembers.refetch();
    this.reviewers = res.data.allMembers
      .slice()
      // @ts-ignore
      .filter((member) => member.isReviewer == true);

    this.$apollo.queries.allArticles.setVariables({
      conference: conf,
    });
    this.$apollo.queries.allArticles.skip = false;
    await this.$apollo.queries.allArticles.refetch();
  }

  async mounted() {
    this.isLoading = true;
    /* if (this.isSuperAdmin) {
      this.$apollo.queries.allConferences.skip = false;
      await this.$apollo.queries.allConferences.refetch();
      const item = localStorage.getItem("conference");
      if (item) {
        const _id = JSON.parse(item)._id;
        await this.reloadSuperAdmin(_id);
      }
      // @ts-ignore
      else await this.reloadSuperAdmin(this.allConferences[0]._id);
    } else {*/
    const item = localStorage.getItem("conference");
    // @ts-ignore
    const _id = JSON.parse(item)._id;
    if (
      this.hasEditMembers ||
      this.hasEditAdmins ||
      this.hasEditArticles ||
      this.isSuperAdmin
    ) {
      this.$apollo.queries.allMembers.setVariables({
        conference: _id,
      });
      this.$apollo.queries.allMembers.skip = false;
      const res = await this.$apollo.queries.allMembers.refetch();
      this.reviewers = res.data.allMembers
        .slice()
        // @ts-ignore
        .filter((member) => member.isReviewer == true);
    }
    if (this.hasEditArticles || this.isSuperAdmin) {
      this.$apollo.queries.allArticles.setVariables({
        conference: _id,
      });
      this.$apollo.queries.allArticles.skip = false;
      await this.$apollo.queries.allArticles.refetch();
    }
    // }
    // @ts-ignore
    this.isLoading = false;
  }

  display: any = {
    addMembers: false,
    members: false,
    chairmen: false,
    insertConference: false,
    carousel: false,
    about: false,
    dates: false,
    info: false,
    topics: false,
    publication: false,
    programme: false,
    venue: false,
    registration: false,
    sponsors: false,
    articles: false,
    isAdmin: false,
  };

  // Conference

  displayEditConference(item: string) {
    this.item = item;
    Object.keys(this.display).forEach((key) => (this.display[key] = false));
    this.display[item] = true;
  }

  async insertConference(conference: IConference) {
    const res = await this.$apollo.mutate({
      mutation: insertConference(conference),
    });
    if (res) alert("inserted successfully");
    else alert("an error has occured");
  }

  async editConference(conference: IConference) {
    const res = await this.$apollo.mutate({
      mutation: editConference(conference),
    });
    if (res) alert("updated successfully");
    else alert("an error has occured");
  }

  async deleteConference() {
    const res = await this.$apollo.mutate({
      mutation: deleteConference(this.conference),
    });
    if (res) alert("deleted successfully");
    else alert("an error has occured");
  }

  // Content
  section = "";
  displayEditContent(item: string) {
    this.item = item;
    Object.keys(this.display).forEach((key) => (this.display[key] = false));
    this.display[item] = true;
    this.section = item;
  }
  async update(content: IContent) {
    content.section = this.section;
    content.conference = this.conference;
    const res = await this.$apollo.mutate({
      mutation: updateContent(content),
    });

    if (res) {
      this.$apollo.queries.allContent.skip = false;
      await this.$apollo.queries.allContent.refetch();
      // @ts-ignore
      this.$store.commit("setContent", this.allContent);
      alert("updated successfully");
    } else alert("an error has occured");
  }

  async insertTopic(topic: ITopic) {
    topic.conference = this.conference;
    await this.$apollo
      .mutate({
        mutation: insertTopic(topic),
      })
      .catch((err) => {
        console.log(err);
      });
    alert("New Topic Inserted!");
  }

  async deleteTopic(title: string) {
    const res = await this.$apollo
      .mutate({
        mutation: deleteTopic(title, this.conference),
      })
      .catch((err) => {
        console.log(err);
      });
    if (res) alert("Topic Deleted!");
    else alert("Incorrect Title!");
  }

  // Chairmen

  async updateChairman(member: IMember) {
    member.conference = this.conference;
    const res = await this.$apollo
      .mutate({
        mutation: updateChairman(member),
      })
      .catch((err) => {
        console.log(err);
      });
    if (res) {
      alert("Updated Successfully!");
      this.$apollo.queries.allMembers.skip = false;
      await this.$apollo.queries.allMembers.refetch();
      this.displayEditChairmen(this.item);
    } else alert("an error has occured!");
  }

  async updateCoChairman(member: IMember) {
    member.conference = this.conference;
    const res = await this.$apollo
      .mutate({
        mutation: updateCoChairman(member),
      })
      .catch((err) => {
        console.log(err);
      });
    if (res) {
      alert("Updated Successfully!");
      this.$apollo.queries.allMembers.skip = false;
      await this.$apollo.queries.allMembers.refetch();
      this.displayEditChairmen(this.item);
    } else alert("an error has occured!");
  }

  async updateHonoraryChairman(member: IMember) {
    member.conference = this.conference;
    const res = await this.$apollo
      .mutate({
        mutation: updateHonoraryChairman(member),
      })
      .catch((err) => {
        console.log(err);
      });
    if (res) {
      alert("Updated Successfully!");
      this.$apollo.queries.allMembers.skip = false;
      await this.$apollo.queries.allMembers.refetch();
      this.displayEditChairmen(this.item);
    } else alert("an error has occured!");
  }

  async updateScientificCommitteeChairman(member: IMember) {
    member.conference = this.conference;
    const res = await this.$apollo
      .mutate({
        mutation: updateScientificCommitteeChairman(member),
      })
      .catch((err) => {
        console.log(err);
      });
    if (res) {
      alert("Updated Successfully!");
      this.$apollo.queries.allMembers.skip = false;
      await this.$apollo.queries.allMembers.refetch();
      this.displayEditChairmen(this.item);
    } else alert("an error has occured!");
  }

  async updateMainOrganizer(member: IMember) {
    member.conference = this.conference;
    const res = await this.$apollo
      .mutate({
        mutation: updateMainOrganizer(member),
      })
      .catch((err) => {
        console.log(err);
      });
    if (res) {
      alert("Updated Successfully!");
      this.$apollo.queries.allMembers.skip = false;
      await this.$apollo.queries.allMembers.refetch();
      this.displayEditChairmen(this.item);
    } else alert("an error has occured!");
  }

  // Members

  currentMembers: any = [];

  async updateMember(member: IMember) {
    member.conference = this.conference;
    const res = await this.$apollo
      .mutate({
        mutation: updateMember(member),
      })
      .catch((err) => {
        console.log(err);
      });
    if (res) {
      alert("Updated Successfully!");
      this.$apollo.queries.allMembers.skip = false;
      await this.$apollo.queries.allMembers.refetch();
      this.displayEditMembers(this.item);
    } else alert("an error has occured!");
  }

  async addMember(member: IMember) {
    member.conference = this.conference;
    const res = await this.$apollo
      .mutate({
        mutation: addMember(member),
      })
      .catch((err) => {
        console.log(err);
      });
    if (res) {
      alert("Added Successfully!");
      this.$apollo.queries.allMembers.skip = false;
      await this.$apollo.queries.allMembers.refetch();
    } else alert("an error has occured!");
  }
  async deleteMember(member: IMember) {
    member.conference = this.conference;
    const res = await this.$apollo
      .mutate({
        mutation: deleteMember(member),
      })
      .catch((err) => {
        console.log(err);
      });
    if (res) {
      alert("Member deleted Successfully!");
      this.$apollo.queries.allMembers.skip = false;
      await this.$apollo.queries.allMembers.refetch();
    } else alert("an error has occured!");
  }

  displayEditMembers(item: string) {
    this.item = item;
    if (item == "addMembers") {
      Object.keys(this.display).forEach((key) => (this.display[key] = false));
      this.display.addMembers = true;
      return;
    }
    // @ts-ignore
    if (!this.allMembers) return;
    if (item == "allMembers")
      // @ts-ignore
      this.currentMembers = this.allMembers;
    else {
      // @ts-ignore
      this.currentMembers = this.allMembers
        .slice()
        .filter((member: any) => member[item] == true);
    }

    Object.keys(this.display).forEach((key) => (this.display[key] = false));
    this.display.members = true;
  }
  displayEditChairmen(item: string) {
    this.item = item;
    // @ts-ignore
    if (!this.allMembers) return;

    // @ts-ignore
    this.currentMembers = this.allMembers;

    Object.keys(this.display).forEach((key) => (this.display[key] = false));
    this.display.chairmen = true;
  }

  // Articles
  currentArticles: IArticle[] = [];
  item = "";
  displayEditArticles(item: string) {
    this.item = item;
    // @ts-ignore
    if (!this.allArticles) return;
    if (item == "accepted")
      // @ts-ignore
      this.currentArticles = this.allArticles
        .slice()
        .filter((article: any) => article["status"] == true);
    if (item == "rejected")
      // @ts-ignore
      this.currentArticles = this.allArticles
        .slice()
        .filter((article: any) => article["status"] == false);
    if (item == "underReview")
      // @ts-ignore
      this.currentArticles = this.allArticles
        .slice()
        .filter((article: any) => article["status"] == null);
    Object.keys(this.display).forEach((key) => (this.display[key] = false));
    this.display.articles = true;
  }

  async updateArticle(article: IArticle) {
    article.conference = this.conference;
    const res = await this.$apollo
      .mutate({
        mutation: updateArticle(article),
      })
      .catch((err) => {
        console.log(err);
      });
    if (res) {
      alert("Updated Successfully!");
      this.$apollo.queries.allArticles.skip = false;
      await this.$apollo.queries.allArticles.refetch();
      this.displayEditArticles(this.item);
    } else alert("an error has occured!");
  }
  async updateRole(_id: string, role: string) {
    const res = await this.$apollo
      .mutate({
        mutation: updateRole(this.conference, _id, role),
      })
      .catch((err) => {
        console.log(err);
      });
    if (res) {
      alert("Updated Successfully!");
      this.$apollo.queries.allArticles.skip = false;
      await this.$apollo.queries.allArticles.refetch();
      this.displayEditArticles(this.item);
    } else alert("an error has occured!");
  }
  async sendAcceptanceLetter(_id: string) {
    const res = await this.$apollo
      .mutate({
        mutation: sendAcceptanceLetter(this.conference, _id),
      })
      .catch((err) => {
        console.log(err);
      });
    if (res) {
      alert("Acceptance Letter Sent!");
      this.$apollo.queries.allArticles.skip = false;
      await this.$apollo.queries.allArticles.refetch();
      this.displayEditArticles(this.item);
    } else alert("an error has occured!");
  }

  async reviewArticle(_id: string, review: boolean | null) {
    const res = await this.$apollo
      .mutate({
        mutation: reviewArticle(this.conference, _id, review),
      })
      .catch((err) => {
        console.log(err);
      });
    if (res) {
      alert("Review Submitted!");
      this.$apollo.queries.allArticles.skip = false;
      await this.$apollo.queries.allArticles.refetch();
      this.displayEditArticles(this.item);
    } else alert("an error has occured!");
  }

  // Admins

  displayEditAdmins(item: string) {
    this.item = item;
    // @ts-ignore
    if (!this.allMembers) return;
    // @ts-ignore
    this.currentMembers = this.allMembers
      .slice()
      .filter((member: any) => member[item] == true);

    Object.keys(this.display).forEach((key) => (this.display[key] = false));
    this.display.isAdmin = true;
  }

  async updateAdmin(member: IMember) {
    member.conference = this.conference;
    const res = await this.$apollo
      .mutate({
        mutation: updateAdmin(member),
      })
      .catch((err) => {
        console.log(err);
      });
    if (res) {
      alert("Updated Successfully!");
      this.$apollo.queries.allMembers.skip = false;
      await this.$apollo.queries.allMembers.refetch();
      this.displayEditAdmins(this.item);
    } else alert("an error has occured!");
  }
}
